<script setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <section class="announcement">
    <h4 v-html="t('venue.comingSoon')"></h4>
  </section>
</template>

<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300..700;1,300..700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=League+Gothic&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Doto:wght@100..900&family=Mea+Culpa&display=swap');
</style>

<style scoped>
/* ---------- SECTION OFFSET FOR FIXED NAV ---------- */
.announcement {
  min-height: calc(100vh - 120px);   /* subtract nav height */
  padding-top: 120px;                /* same as nav height */
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

/* ---------- TEXT ---------- */
h4 {
  font-family: 'Montserrat', sans-serif;
  font-size: 6rem;
  font-weight: 300;
  color: #000;
  margin: 0;
}

/* ---------- RESPONSIVE ---------- */
@media (max-width: 1024px) {
  h4 {
    font-size: 4rem;
  }
}

@media (max-width: 768px) {
  .announcement {
    min-height: calc(100vh - 90px);
    padding-top: 90px;
  }

  h4 {
    font-size: 3rem;
  }
}

@media (max-width: 480px) {
  h4 {
    font-size: 2rem;
  }
}
</style>
